/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import DropDown from 'app/components/common/DropDown.jsx';
import { shutdownIntercom } from 'app/utility/Intercom.js';
import NotificationHeader from 'app/components/DropDownItems/NotificationHeader.jsx';
import NotificationItem from 'app/components/DropDownItems/NotificationItem.jsx';
import NavigationItem from 'app/components/DropDownItems/NavigationItem.jsx';
import * as _ from "underscore";

class Tabs extends React.Component {
	render() {
		let tabs = this.props.items.map((item, i) => {
			let linkClass = 'nav-icon';
			let queueNotice = '';

			if (this.props.router.location && this.props.router.location.pathname.match(item.regex)) {
				linkClass += ' active';
			}

			// if(item.title === 'Queue' && !this.props.queueCount) {
			// 	queueNotice = <div className="nav-notice"><i className="fa fa-circle"></i></div>;
			// }

			return (
				<Link to={item.data} className={linkClass} key={i} title={item.title} alt={item.title}>
					<i className={item.iconClass}  data-item={item.data}></i>
					<span className="nav-item-title">{item.title}</span>
					{queueNotice}
				</Link>
			);
		});

		return (<nav role="navigation">{tabs}</nav>);
	}
};

class Nav extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeMenuItem: 'automate',
			notificationShow: false,
			accountDropdown: false,
			allClear: false,
			queueCount: 0
		};

		this.sendPromoView = this.sendPromoView.bind(this);
		this.setActiveMenuItem = this.setActiveMenuItem.bind(this);
		this.notificationToggle = this.notificationToggle.bind(this);
		this.showAccountOptions = this.showAccountOptions.bind(this);
		this.onAccountOptionClick = this.onAccountOptionClick.bind(this);
		this.onNoticeMouseOver = this.onNoticeMouseOver.bind(this);
		this.onNoticeMouseOut = this.onNoticeMouseOut.bind(this);
		this.onUpgrade = this.onUpgrade.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);

	}

	componentDidMount() {

		if (!_.isEmpty(this.props.user.perms)) {
			this.sendPromoView(this.props);
		}

		this.props.getNotices();

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.router.location && !this.props.router.location.pathname.match(/subscription/)) {
			if (_.isEmpty(prevProps.user.perms) && !_.isEmpty(this.props.user.perms)) {
				this.sendPromoView(this.props);
			}
		}

		let plusTrialAvailable = this.state.plusTrialAvailable;

		if (this.props.user.detail.trialEndsAt && this.props.user.detail.trialEndsAt !== "") {
			if (new Date(this.props.user.detail.trialEndsAt) < new Date() && this.props.user.detail.pubLevel > 1) {
				plusTrialAvailable = true;
			} else if (new Date(this.props.user.detail.trialEndsAt) > new Date() && this.props.user.detail.pubLevel > 1) {
				plusTrialAvailable = false;
			}
		} else if (this.props.app.flags.plusTrialAvailable && this.props.user.detail.pubLevel > 1) {
			plusTrialAvailable = true;
		}
		if (plusTrialAvailable != this.state.plusTrialAvailable) {
			this.setState({
				plusTrialAvailable
			});
		}

		if (prevProps.app.loading.NOTIFICATIONS_CLEAR === true && this.props.app.loading.NOTIFICATIONS_CLEAR === false) {
			this.props.getNotices();
		}

	}

	sendPromoView(props) {
		let creative = (parseInt(props.user.detail.pubLevel, 10) > 1) ? 'upgrade_button.upgrade' : 'upgrade_button.new',
			version = '',
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

			if (onboarding === null) {
				if (dataLayer && parseInt(props.user.detail.id, 10) !== 0) {
					if (parseInt(props.user.detail.pubLevel, 10) > 1) {
						version = ".power";
					} else {
						//version = (parseInt(props.userId, 10) % 2) ? "trial-100%" : "trial-90%";
					}

				if (this.state.plusTrialAvailable) {
					creative += version + ".plus";
				} else {
					creative += version;
				}

				// dataLayer.push({
				// 	'event': 'promotionView',
				// 	'ecommerce': {
				// 		'promoView': {
				// 			'promotions': [
				// 				{
				// 					'id': 'upgrade_button',
				// 					'name': 'Upgrade Button',
				// 					'creative': creative,
				// 					'position': 'nav_banner'
				// 				}
				// 			]
				// 		},
				// 	},
				// 	// GA4 promo view params
                //     'promotion_id': 'upgrade_button',
                //     'promotion_name': 'Upgrade Button',
                //     'creative_name': creative,
                //     'creative_slot': 'nav_banner',
				// 	items: [
                //         {
                //             item_id: 'dlvrit_1',
                //             item_name: 'dlvr.it premium plan',
                //             price: 1.00,
                //             quantity: 1
                //         }
                //     ]
				// });

				if (gtag) {
					gtag('event', 'view_promotion', {
						'promotion_id': 'upgrade_button',
	                    'promotion_name': 'Upgrade Button',
	                    'creative_name': creative,
	                    'creative_slot': 'nav_banner',
						items: [
	                        {
	                            item_id: 'dlvrit_1',
	                            item_name: 'dlvr.it premium plan',
	                            price: 1.00,
	                            quantity: 1
	                        }
	                    ]
					});
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Upgrade Button View',
						event_data: {
							button: creative
						}
					});
				}
			}
		}
	}

	setActiveMenuItem(items, item) {
		this.setState({activeMenuItem: item.data});
	}

	notificationToggle() {
		let notificationBoolean = this.state.notificationShow ? false : true;
		this.setState({notificationShow: notificationBoolean});
	}

	showAccountOptions(e) {
		let dropdown = this.state.accountDropdown ? false : true;

		e.preventDefault();

		this.setState({
			accountDropdown: dropdown
		});

	}

	onAccountOptionClick(action, e) {

		if (action === 'settings') {
			this.props.router.navigate("/account");
		} else if (action === 'sign-out') {
			shutdownIntercom();
			window.location.href = "/signout.php";
		} else if (action === 'support') {
			window.location.href = this.props.app.config.supportUrl;
		}

		this.setState({
			accountDropdown: false
		});
	}

	onNoticeMouseOver(e) {
		this.setState({
			allClear: true
		});
	}

	onNoticeMouseOut(e) {
		if (e.currentTarget.className === "icon-wrap" && (e.relatedTarget && e.relatedTarget.className === "notification-all-clear")) {
			return;
		}

		this.setState({
			allClear: false
		});
	}

	onUpgrade(e) {

		e.preventDefault();

		let that = this,
			redirector = function() {
				// if (!that.props.trialEligible && !that.props.isFreeUser()) {
				// 	if (that.props.isProUser()) {
				// 		that.props.router.navigate('/account/subscription/plus');
				// 		return;
				// 	}
				// }
				if (that.props.isFreeUser()) {
					that.props.router.navigate('/account/subscription/new?plan=6');
				} else {
					that.props.router.navigate('/account/subscription');
				}
			};

		if (dataLayer) {
			let creative = '';

			// ternary operator breaking in firefox for some reason...
			if (parseInt(this.props.user.detail.pubLevel, 10) > 1) {
				creative = 'upgrade_button.upgrade.power';
			} else {
				creative = 'upgrade_button.new';
				//creative += (parseInt(this.props.userId, 10) % 2) ? "trial-100%" : "trial-90%";
			}

			// if (this.props.user.detail.trialEligible) {
			// 	if (parseInt(this.props.userId, 10) % 2) {
			// 		creative += "6";
			// 	} else {
			// 		creative += "7";
			// 	}
			// } else {
			// 	creative += "2";
			// }

			//creative += (parseInt(this.props.userId, 10) % 2) ? "green" : "power";

			// if (!this.props.trialEligible && this.state.plusTrialAvailable) {
			// 	creative += ".plus";
			// }

			if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Upgrade Button Click',
                    event_data: {
                        button: creative
                    }
                });
            }

			if (gtag) {
				gtag('event', 'select_promotion', {
					// GA4 promo view params
                    'promotion_id': 'upgrade_button',
                    'promotion_name': 'Upgrade Button',
                    'creative_name': creative,
                    'creative_slot': 'nav_banner',
					items: [
	                    {
	                        item_id: 'dlvrit_1',
	                        item_name: 'dlvr.it premium plan',
	                        price: 1.00,
	                        quantity: 1
	                    }
	                ]
				});

				this.props.persistData('gaPromo', {
					promotion_id: 'upgrade_button',
					promotion_name: 'Upgrade Button'
				});

			}

			// if (dataLayer && window.ga && ga.loaded) {
			// 	dataLayer.push({
			// 		'event': 'promotionClick',
			// 		'ecommerce': {
			// 			'promoClick': {
			// 				'promotions': [
			// 					{
			// 						'id': 'upgrade_button',
			// 						'name': 'Upgrade Button',
			// 						'creative': creative,
			// 						'position': 'nav_banner'
			// 					}
			// 				]
			// 			}
			// 		},
			// 		'eventCallback': function() {
			// 			// if (!that.props.trialEligible && !that.props.isFreeUser()) {
			// 			// 	if (that.props.isProUser()) {
			// 			// 		that.props.router.navigate('/account/subscription/plus');
			// 			// 		return;
			// 			// 	}
			// 			// }
			// 			that.props.router.navigate('/account/subscription');
			// 		},
			// 		// GA4 promo view params
            //         'promotion_id': 'upgrade_button',
            //         'promotion_name': 'Upgrade Button',
            //         'creative_name': creative,
            //         'creative_slot': 'nav_banner',
			// 		items: [
	        //             {
	        //                 item_id: 'dlvrit_1',
	        //                 item_name: 'dlvr.it premium plan',
	        //                 price: 1.00,
	        //                 quantity: 1
	        //             }
	        //         ]
			// 	});
			// } else {
			// 	redirector();
			// }

			redirector();

		}


	}

	closeDropdown(which) {

		if (which === "notices") {
			this.setState({
				notificationShow: false
			});
		} else if (which === "account") {
			this.setState({
				accountDropdown: false
			});
		}


	}

	render() {
		let logoUrl = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100.png'].join(''),
			logoUrl2X = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100@2x.png'].join(''),
			notifications = null,
			notificationHeader = null,
			notificationButton = null,
			accountOptions = [
				{action: 'settings', icon: 'fa fa-user', label: 'Account Settings'},
				{action: 'support', icon: 'fa fa-life-ring', label: 'Support'},
				{action: 'sign-out', icon: 'fa fa-sign-out', label: 'Sign Out'}
			],
			accountDropdown = null,
			userImage = (
				<div className="nav-user-image">
					<span className="va-helper"></span>
					<img src={this.props.user.detail.avatar} className="user-img"/>
				</div>
			),
			iconClass = "notice-warning",
			accountButtonClass = classnames('app-column', 'nav', 'right', 'account-options', {
				'active': (this.props.router.location && this.props.router.location.pathname.match(/\/config\/account/)) ? true : false
			}),
			planButtonText = '',
			version = 0,
			centerRightClass = 'nav-center-right',
			upgradeButtonClass = 'upgrade-button',
			upgradeButton = null,
			constants = this.props.app.config.constants,
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
			topNavTabs = (this.props.appName === "dlvr") ? this.props.tabs : [];


		if (parseInt(this.props.user.detail.id, 10) === 0) {
			return null;
		}

		// if (parseInt(this.props.user.detail.pubLevel, 10) > 1) {
		// 	centerRightClass += (' v2 expand');
		// 	upgradeButtonClass += " v2";
		// } else {
		// 	if (this.props.user.detail.trialEligible) {
		// 		if (parseInt(this.props.userId, 10) % 2) {
		// 			upgradeButtonClass += " v6";
		// 		} else {
		// 			upgradeButtonClass += " v7";
		// 		}
		// 		centerRightClass += ' v5';
		// 	} else {
		// 		centerRightClass += (' v2');
		// 		upgradeButtonClass += " v2";
		// 	}
		// }

		if (!_.isEmpty(this.props.user.detail) && this.props.appName === "dlvr") {
			//var version = (parseInt(this.props.userId, 10) % 2) ? " v7" : " v11";
			version = " v7";

			if (!this.props.isTrialUser() && !this.props.isFreeUser()) {
				planButtonText = (
					<span><i className="icon ion-flash"/> Want more power?</span>
				);
				upgradeButtonClass += " v11";
				centerRightClass += " v11";
			} else if (this.props.isFreeUser()) {
				planButtonText = (
					<span>Get Unlimited Posting</span>
				);
				upgradeButtonClass += " v11";
				centerRightClass += " v11";
			} else {
				if (this.props.user.detail.trialDaysLeft > 1) {
					planButtonText = (
						<span><i className="icon ion-flash"/> Upgrade now - {this.props.user.detail.trialDaysLeft} days left in trial</span>
					);
				} else if (this.props.user.detail.trialDaysLeft === 1) {
					planButtonText = (
						<span><i className="icon ion-flash"/> Upgrade now - Free trial ends today!</span>
					);
				} else {
					planButtonText = (
						<span><i className="icon ion-flash"/> Upgrade now</span>
					);
				}
				upgradeButtonClass += ' v11';
				centerRightClass += ' v11';
			}

			// if ((parseInt(this.props.userId, 10) % 2)) {
			// 	if (parseInt(this.props.user.detail.pubLevel, 10) > 1) {
			// 		if (this.props.subscriptionTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
			// 			planButtonText = 'Complete Upgrade';
			// 			centerRightClass += ' v6';
			// 			upgradeButtonClass += version;
			// 		} else {
			// 			planButtonText = 'Grow Your Plan';
			// 			if (this.state.plusTrialAvailable) {
			// 				version = " v7";
			// 				planButtonText = "Try Plus Free";
			// 			}
			// 			centerRightClass += ' v5 upgrade';
			// 			upgradeButtonClass += version + ' upgrade';
			// 		}
			// 	} else {
			// 		planButtonText = 'Upgrade';
			// 		if (this.props.user.detail.trialEligible) {
			// 			planButtonText = 'Try Pro Free';
			// 			centerRightClass += ' v5';
			// 			upgradeButtonClass += version;
			// 		} else {
			// 			centerRightClass += ' v3';
	 		// 			upgradeButtonClass += version;
			// 		}
			// 	}
			// } else {
			// 	planButtonText = "Want more power?";
			// 	upgradeButtonClass += version;
			// 	centerRightClass += version;
			// }

		}

		if (this.state.notificationShow) {
			notificationHeader = (
				<NotificationHeader
					{...this.props}
					count={this.props.notifications.length}/>
			);
			notifications = <DropDown id="notices"
									  {...this.props}
									  items={this.props.notifications}
									  itemElement={NotificationItem}
									  dropDownClass="notification-dd"
									  clickHandler={this.notificationToggle}
									  listHeader={notificationHeader}
									  resetHandler={this.closeDropdown} />
		}


		if (this.state.accountDropdown) {
			accountDropdown = <DropDown
								id="account"
								items={accountOptions}
								itemElement={NavigationItem}
								dropDownClass="account-dd"
								clickHandler={this.onAccountOptionClick}
								resetHandler={this.closeDropdown}/>;
		}

		if (this.props.notifications && this.props.notifications.length) {
			// look for terminal notices
			if (_.where(this.props.notifications, {type: "10"}).length) {
				iconClass = "notice-terminal";
			}
			notificationButton = (
				<div className="icon-wrap" onClick={this.notificationToggle} role="button" aria-label="show notifications">
					<i className={"fa fa-bell " + iconClass}></i>
					<span className="nav-alert-badge">{this.props.notifications.length}</span>
				</div>
			);
		} else {
			notificationButton = (
				<div className="icon-wrap" onMouseOver={this.onNoticeMouseOver} onMouseOut={this.onNoticeMouseOut}>
					<i className="fa fa-bell notice-all-clear"></i>
				</div>
			);
		}

		if (this.state.allClear) {
			notifications = (
				<div className="notification-all-clear" onMouseOut={this.onNoticeMouseOut}>
					No new notifications
				</div>
			);
		}

		if (this.props.appName === "dlvr" && this.props.router.location &&
			!this.props.router.location.pathname.match(/subscription/) &&
			!this.props.router.location.pathname.match(/account\/billing/) &&
			!this.props.router.location.pathname.match(/promo/) &&
			onboarding === null) {
			upgradeButton = (
				<div className="btn-wrap">
					<button className={upgradeButtonClass} onClick={this.onUpgrade}>{planButtonText}</button>
				</div>
			);
		} else {
			upgradeButton = (
				<div className="btn-wrap empty"></div>
			);
		}

		return(
			<header className="nav-wrapper" aria-hidden={this.props.modals.stack.length ? true : false}>
				<div className="nav-container">
					<div className="app-column nav left">
						<div className="logo-wrapper">
							<span className="va-helper"></span>
							<Link to={this.props.appName === "dlvr" ? "/share/automate" : "/socials"}>
								<img
			                        src={logoUrl}
									srcSet={`${logoUrl} 1x, ${logoUrl2X} 2x`}
			                        width="31px"
			                        height="100px"
			                        className="nav-logo" />
							</Link>
						</div>
					</div>
					<div className="app-column nav main">
						<div className="nav-center-left">
							<Tabs {...this.props} items={topNavTabs} queueCount={this.state.queueCount} />
						</div>
						<div className={centerRightClass}>
							{upgradeButton}
							<div className="notification-button">
								{notificationButton}
							</div>
							{notifications}
						</div>
					</div>
					<div className={accountButtonClass} onClick={this.showAccountOptions} role="button" aria-label="account">
						{ userImage }
						<div className="nav-user-name" title={this.props.user.detail.username} alt={this.props.user.detail.username}>{this.props.user.detail.username}</div>
						{accountDropdown}
					</div>
				</div>
			</header>
		);
	}
};

Nav.displayName = "Nav";

Nav.propTypes = {
	tabs: PropTypes.array,
	notices: PropTypes.array,
	avatarUrl: PropTypes.string,
	username: PropTypes.string,
	userPerms: PropTypes.object,
	userId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	appName: PropTypes.string
};

Nav.defaultProps = {
	tabs: [
		{iconClass: 'ds-icon icon-add-content', data: '/content/post', regex: /content/, title: 'Publish'},
		{iconClass: 'fa fa-share icon', data: '/share/automate', regex: /share/, title: 'Automate'},
		{iconClass: 'icon ion-android-calendar', data: '/queue', regex: /queue/, title: 'Schedule'},
		{iconClass: 'fa fa-bar-chart icon', data: '/stats', regex: /stats/, title: 'Stats'},
		{iconClass: 'fa fa-paper-plane icon', data: '/config/socials', regex: /config\//, title: 'Outputs'},
		{iconClass: 'fa fa-users icon', data: '/people/team', regex: /people/, title: 'People'}
	],
	notices: [],
	avatarUrl: '',
	username: '',
	userPerms: {},
	userId: 0,
	appName: "dlvr"
};

export default Nav;
